import { Alert, Button } from "react-bootstrap"
import BadgeEstados from "../../BadgeEstado"
import { getActaDetalleHandler } from "../../../handlers/actaDetalle.handler"
import { useGeneralAppStore } from "../../../store/generalAppStore"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { FileXIcon } from "../../Icons";
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';

const Chequear = ({ aPrev, aPos, amp, amt, acta }) => {

    const { handlerModal } = useGeneralAppStore();

    return (
        <div>
            {
                aPos?.some(acta => acta?.estado_id == 8)
                    ?
                    <Alert variant="danger" className="d-flex flex-column gap-2 align-items-center">
                        <div className="bg-white d-flex flex-column align-items-center gap-3 p-2 py-4 border rounded shadow-lg w-100">
                            <div className="d-flex flex-column align-items-center gap-1">
                                <b className="text-center">Se detectaron actas posteriores en <BadgeEstados estado_id={8} /></b>
                                <p className="m-0">Anule el envio marcandolas sin entregar</p>
                                <div className="d-flex gap-2 justify-content-center align-items-center flex-wrap">
                                    {
                                        amp?.filter(acta => acta?.estado_id == 8).map((a, index) => {
                                            return (
                                                <div key={index}
                                                    className={`bg-warning px-2 rounded  text-white fw-bold `}
                                                    style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                    onClick={() => {
                                                        if (index == 0) {
                                                            getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                        }
                                                    }}
                                                >
                                                    <p className="m-0 text-dark">Acta - {a?.numero_acta}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <Button variant="danger" size="sm" className="d-flex gap-1 align-items-center" onClick={() => { handlerModal({ modal: true, modalName: "actas_sin_entregar" }) }}><DoDisturbAltIcon /> Anular envio</Button>
                        </div>
                    </Alert>
                    : (
                        <>
                            {aPrev?.some(acta => [3, 7].includes(acta?.estado_id)) && (

                                <Alert variant="danger" className="d-flex flex-column gap-2 align-items-center">
                                    <div className="bg-white d-flex flex-column align-items-center gap-1 p-2 py-4 border rounded shadow-lg w-100">
                                        <b className="text-center">Se detectaron actas con estados previos</b>
                                        {
                                            aPrev?.some(acta => acta?.estado_id == 3)
                                            &&
                                            <div className="w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">

                                                <p className="m-0 text-center">Revise toda las actas <BadgeEstados estado_id={3} /> para poder seguir</p>
                                                <div className="d-flex flex-wrap gap-2 justify-content-center align-items-center">
                                                    {
                                                        aPrev?.filter(acta => acta?.estado_id == 3).map((a, index) => {
                                                            return (
                                                                <div key={index}
                                                                    className={` px-2 rounded  text-white fw-bold border border-3 ${index == 0 ? 'border-primary bg-secondary' : 'bg-secondary-subtle'}`}
                                                                    style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                                    onClick={() => {
                                                                        if (index == 0) {
                                                                            getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                                        }
                                                                    }}
                                                                >
                                                                    <p className="m-0">Acta - {a?.numero_acta}</p>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {
                                            aPrev?.some(acta => acta?.estado_id == 7)
                                            &&
                                            <div className=" w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">

                                                <p className="m-0 text-center">Complete toda las actas <BadgeEstados estado_id={7} /> para poder seguir</p>
                                                <div className="d-flex justify-content-center align-items-center gap-2">
                                                    {
                                                        aPrev?.filter(acta => acta?.estado_id == 7).map((a, index) => {
                                                            return (
                                                                <div key={index}
                                                                    className={` px-2 rounded  text-white fw-bold border border-3 ${index == 0 ? 'border-primary bg-danger' : 'bg-danger-subtle'}`}
                                                                    style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                                    onClick={() => {
                                                                        if (index == 0) {
                                                                            getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                                        }
                                                                    }}
                                                                >
                                                                    <p className="m-0">Acta - {a?.numero_acta}</p>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </Alert>
                            )}


                            < Alert variant="primary" className="d-flex flex-column gap-2 align-items-center">
                                <div className="bg-white d-flex flex-column align-items-center gap-3 p-4 border rounded shadow-lg w-100">
                                    <span className="text-center">Verifique bien los datos y las imagenes de la infracción y marque segun lo analizado</span>
                                    <div className="d-flex gap-3 flex-wrap justify-content-center">
                                        {!(aPrev?.some(acta => [3, 7].includes(acta?.estado_id))) && <Button variant="success" size="sm" className="d-flex gap-1 align-items-center" onClick={() => { handlerModal({ modal: true, modalName: "aprobada_imprimir" }) }}><CheckCircleIcon /> Aprobar</Button>}
                                        <Button variant="danger" size="sm" className="d-flex gap-1 align-items-center" onClick={() => { handlerModal({ modal: true, modalName: "incompleta_acta_detalle" }) }}><FileXIcon color="#fff" /> Incompleta</Button>
                                        <Button variant="danger" size="sm" className="d-flex gap-1 align-items-center" onClick={() => { handlerModal({ modal: true, modalName: "modal_confirm" }) }}><DoDisturbAltIcon />Anular</Button>
                                    </div>
                                </div>
                            </Alert>
                        </>
                    )
            }
        </div >
    )
}

export default Chequear;